import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// translations sources
import enTranslation from './locales/en.json'
import deTranslation from './locales/de.json'

const resources = {
  en: enTranslation,
  de: deTranslation,
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
